import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

import { RootError } from './RootError';

interface Props {
  message: string;
  cta?: string;
}

export const UnauthorizedError = ({ message, cta = 'Login' }: Props) => {
  const { logout } = useAuth0();

  const handleErrorLogin = () => {
    // Clear any cached auth data and redirect to login
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
    void logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <RootError>
      <p style={{ marginBottom: '20px' }}>{message}</p>
      <Button onClick={handleErrorLogin} variant="contained" color="primary" size="large">
        {cta}
      </Button>
    </RootError>
  );
};
